import getArray from 'utils/accessors/getArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import nullBind from 'utils/functions/nullBind.util';

// These are the most simple getters,
// they will navigate the path, return the data found
// or most of them default to null for null/undefined
// but some default to an empty array

export const selectParsedToken = ($) => $?.lib?.parsedToken ?? null;
export const selectLatestUiActionTime = ($) => $?.lib?.latest?.now ?? null;
export const selectLockToken = ($) => $?.lib?.lockToken ?? null;
export const selectPinUserIsPrimary = ($) => $?.lib?.userPrimary ?? null;
export const selectUserNameFromPin = ($) => $?.lib?.userName ?? null;
export const selectUserRoleFromPin = ($) => $?.lib?.userRole ?? null;
export const selectUserStylistId = ($) => $?.lib?.stylistId ?? null;
export const selectPinUserIsCustomerSupport = ($) => $?.lib?.isCustomerSupport ?? null;

export const selectUserRoleFromSalon = ($) => $?.salon?.userPermission?.permission ?? null;

// defaults to empty array
export const selectClientTagsFromSalon = nullBind(getArray, 'salon.customClientTags.clientTags');
export const selectCurrentClientTags = nullBind(getArray, 'clientProfile.client.clientTags');
export const selectEditedClientTags = nullBind(getArray, 'clientProfile.edit_client.data.client_tags');
export const selectBookingClientTags = nullBind(getArray, 'booking.client.client_tags');

// this is a simple composition of two functions, usually a simple transformation
export const selectHasLockToken = (store) => fromAnyToBool(selectLockToken(store));
